Ext.define('SA.TickFormatter', {
    singleton: true,

    maxDecimals: 2,

    get({values, formatter = new SA.NumberFormatter()}) {
        var power = Math.max(...values.map(value => SA.PowersOfThousand.getPower(value))),
            decimals = this.getDecimals({values, power});

        return formatter.set({decimals, power});
    },

    getDecimals({values, power}) {
        var significands = values.map(value => SA.PowersOfThousand.toPower(value, power)),
            significandsRounded = significands.map(value => value.toFixed(this.maxDecimals)),
            decimals = significandsRounded.map(value => SA.Number.countDecimalPlaces(value));

        return Math.max(...decimals);
    }
});